import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { XmlImportError, XmlImportSummary } from '@common/models/XmlImportReport.model';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { XmlImportSeverityTypes } from '../../knownTypes/XmlImportSeverityTypes';

@Component({
    selector: 'app-xml-import-report',
    templateUrl: './xml-import-report.component.html',
    styleUrls: ['./xml-import-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class XmlImportReportComponent implements OnInit {
    title: string;
    summary: XmlImportSummary;
    errors: XmlImportError[] = [];

    filterSeverity: XmlImportSeverityTypes = XmlImportSeverityTypes.All;
    searchText: string = '';

    filteredErrors: XmlImportError[] = [];

    readonly severityCodeListValues = Object.values(XmlImportSeverityTypes).map((v) => ({ id: v, name: v }));

    constructor(public dialog: DialogRef) {}

    ngOnInit(): void {
        this.applyFilter();
    }

    applyFilter(): void {
        let result = this.errors || [];

        if (this.filterSeverity !== XmlImportSeverityTypes.All) {
            result = result.filter((e) => (e.severity ?? XmlImportSeverityTypes.Error) === this.filterSeverity);
        }

        if (this.searchText?.trim()) {
            const search = this.searchText.trim().toLowerCase();
            result = result.filter(
                (e) =>
                    (e.containerNumber || '').toLowerCase().includes(search) ||
                    (e.message || '').toLowerCase().includes(search) ||
                    (e.identificator || '').toLowerCase().includes(search)
            );
        }

        this.filteredErrors = result;
    }

    get hasErrors(): boolean {
        return (this.errors || []).length > 0;
    }

    get noResults(): boolean {
        return this.hasErrors && this.filteredErrors.length === 0;
    }

    getSeverityClass(severity: XmlImportSeverityTypes | undefined): string {
        switch (severity ?? XmlImportSeverityTypes.Error) {
            case XmlImportSeverityTypes.Error:
                return 'text-danger';
            case XmlImportSeverityTypes.Warning:
                return 'text-warning';
            case XmlImportSeverityTypes.Info:
                return 'text-info';
            default:
                return '';
        }
    }

    getSeverityIcon(severity: XmlImportSeverityTypes | undefined): any {
        switch (severity ?? XmlImportSeverityTypes.Error) {
            case XmlImportSeverityTypes.Error:
                return ['fas', 'times-circle'];
            case XmlImportSeverityTypes.Warning:
                return ['fas', 'exclamation-triangle'];
            case XmlImportSeverityTypes.Info:
                return ['fas', 'info-circle'];
            default:
                return ['fas', 'question-circle'];
        }
    }

    close(): void {
        this.dialog.close(null);
    }
}
